import { z } from 'zod';

export const companyLogosSchema = z.object({
  items: z.record(
    z.string(),
    z.object({
      favicon_url: z.string().nullable(),
      logo_url: z.string().nullable(),
    }),
  ),
});

export const newlyFoundedSchema = z.object({
  items: z.array(
    z.object({
      eu_id: z.string(),
      name: z.string(),
      sitz: z.string().nullish(),
      city: z.string().nullish(),
      rechtsform_code: z.number().nullish(),
      legal_form: z.string().nullish(),
      founded_on: z.iso.date(),
      gruendungsdokument_datum: z.string().nullish(),
      erste_eintragung_datum: z.string().nullish(),
      canonical_name: z.string().nullish(),
      canonical_sitz: z.string().nullish(),
      canonical_register_court: z.string().nullish(),
      canonical_register_type: z.string().nullish(),
      canonical_register_id: z.string().nullish(),
      favicon_url: z.string().nullable(),
      logo_url: z.string().nullable(),
    }),
  ),
});
